
  <h2 mat-dialog-title>
  <div class="task-list-header">

  <!-- First row -->
  <div class="task-list-title-row">

    <span class="task-title">
      Task List - {{ myTaskText }}
    </span>

    <button
      mat-icon-button
      color="primary"
      class="openNew"
      matTooltip="Open task list in new window"
      (click)="OpenTaskListinNewTab()">

      <mat-icon>open_in_new</mat-icon>

    </button>


    <button type="button" class="task-view-option add-task-option" *ngIf="transactionIDForTask > 0"
      matTooltip="Add Task" (click)="createNewTask()">
     <mat-icon>add</mat-icon> One-off task
     </button>

  </div>


  <!-- Second row -->
  <div class="task-subtitle">
    Manage and track all tasks for {{ myTaskText }}.
    {{ completedTasks }} of {{ totalTasks }} tasks completed
  </div>

</div>


    <button mat-icon-button (click)="closeTask()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

<div class="task-progress-summary">

  <div class="summary-row">

    <!-- Title -->
    <span class="summary-title">
      Task Progress Summary
    </span>

    <!-- Completed -->
    <a class="summary-status">
      Completed - <b>{{ completedTasks }}</b>
    </a>

    <!-- Open -->
    <a class="summary-status">
      Open - <b>{{ openTasks }}</b>
    </a>

    <!-- In Progress -->
    <a class="summary-status">
      In Progress - <b>{{ inProgressTasks }}</b>
    </a>

    <!-- Stuck -->
    <a class="summary-status">
      Stuck - <b>{{ blockedTasks }}</b>
    </a>

    <!-- Declined -->
    <a class="summary-status">
      Declined - <b>{{ declinedTasks }}</b>
    </a>


    <!-- RIGHT SIDE ACTIONS -->
    <div class="summary-actions" *ngIf="showMoveToOption">

      <!-- Dropdown -->
     <ng-select
        class="summary-dropdown"
        [searchable]="false"
        [clearable]="false"
        placeholder="Select Status"
        (change)="onTaskFilterChange($event)">

        <ng-option
          *ngFor="let stat of taskStatusList"
          [value]="stat.taskStatusID">

          <span
            class="statusOptions"
            [style.background]="getBackground(stat.taskStatusID)">
            {{ stat.taskStatusName }}
          </span>

        </ng-option>

      </ng-select>


      <!-- Delete -->
      <button
        mat-icon-button
        class="summary-delete"
        matTooltip="Delete selected tasks"
        (click)="deleteMultipleTask()">

        <mat-icon>delete</mat-icon>

      </button>

    </div>

  </div>

</div>

<br>

  
   <mat-dialog-content>
    
    <div class="">     
     
   <div class="task-table-container">

  <!-- =====================================================
       TABLE HEADER
       ===================================================== -->

  <div class="task-table-header">

    <!-- Title -->
    <div class="header-cell header-title">

      <mat-checkbox
        class="header-checkbox"
        color="primary"
        [disabled]="ShowNoRecordFound"
        [checked]="isAllSelected()"
        [indeterminate]="isSomeSelected()"
        (change)="masterToggle()">
      </mat-checkbox>

      <span>Title</span>

    </div>

    <!-- Required -->
    <div class="header-cell header-required">
      Required
    </div>

    <!-- Assignee -->
    <div class="header-cell header-assignee">
      Assignee
    </div>

    <!-- Due date -->
    <div class="header-cell header-due">
      Due date
    </div>

    <!-- Status -->
    <div class="header-cell header-status">
      Status
    </div>

    <!-- Priority -->
    <div class="header-cell header-priority">
      Priority
    </div>

    <!-- Action -->
    <div class="header-cell header-action">
      Action
    </div>

  </div>


  <!-- =====================================================
       TASK GROUPS
       ===================================================== -->

  <div
    class="task-groups"
    *ngFor="let column of columns">

    <div
      class="task-group-container"
      cdkDropList
      [cdkDropListData]="column.groups"
      (cdkDropListDropped)="dropGroup($event)">


      <!-- =================================================
           GROUP
           ================================================= -->

      <mat-card
        class="task-group-card"
        *ngFor="let group of column.groups"
        cdkDropListGroup
        cdkDrag
        [cdkDragDisabled]="group.dragDisabled"
        [cdkDragData]="group">


        <!-- Group title -->

        <div
          class="task-group-header"
          *ngIf="taskListID > 0 && group.id != 0">

          <div class="group-title">

            <ng-container *ngIf="group.id == 0">
              {{ group.title }}
            </ng-container>

            <input
              *ngIf="group.id > 0"
              type="text"
              maxlength="50"
              [value]="group.title"
              (change)="onChangeGroupName($event,group)"
              class="group-title-input">

          </div>


          <button
            *ngIf="group.id > 0"
            mat-icon-button
            class="group-delete-button"
            (click)="removeGroup(group)">

            <mat-icon>delete_outline</mat-icon>

          </button>

        </div>


        <!-- =================================================
             TASK LIST
             ================================================= -->

        <form [formGroup]="statusGroup">

          <div
            class="task-list"
            cdkDropList
            [id]="group.id"
            [cdkDropListData]="group.items"
            (cdkDropListDropped)="dropItem($event)"
            [cdkDropListConnectedTo]="getConnectedList()">


            <!-- =================================================
                 TASK ROW
                 ================================================= -->

            <div
              class="task-row"
              *ngFor="let item of group.items; let i = index"
              cdkDrag
              [cdkDragData]="item"
              [cdkDragDisabled]="taskListID == 0"

              [ngClass]="{
                'completed-row':
                item.status == completedTaskStatusID
              }">


              <!-- =================================================
                   1. TASK TITLE
                   ================================================= -->

              <div class="task-cell task-title-cell">

                <!-- Checkbox -->

                <mat-checkbox
                  class="task-checkbox"
                  color="primary"
                  [checked]="selection.isSelected(item)"
                  (change)="isAllSelectedRow($event,item)">
                </mat-checkbox>


                <!-- Complete button -->

             <mat-icon
            class="complete-icon"
            (click)="markComplete(item)"
            [ngClass]="{
              'completed': item.status == completedTaskStatusID
            }">
            check_circle_outline
          </mat-icon>


                <!-- Task content -->

                <div
                  class="task-main-content"
                  (click)="getTaskDetail(item)">


                  <!-- Task title -->

                  <div class="task-title-line">

                    <!-- Color -->

                    <span
                      class="task-color-dot"

                      [ngStyle]="{
                        'background-color':
                        taskListID == 0 &&
                        taskListIDSharedWithMe == 0
                        ? item.color
                        : item.colourCode
                      }">
                    </span>


                    <!-- Title -->

                    <span
                      class="task-title"
                      [ngClass]="{
                        'completed-task':
                        item.status == completedTaskStatusID
                      }">

                      {{ item.taskTitle }}

                    </span>

                  </div>


                  <!-- =================================================
                       TASK META / TAGS
                       ================================================= -->

                  <div class="task-meta">


                    <!-- Action -->

                    <span
                      class="task-tag task-tag-form"
                      *ngIf="taskAction(item) as act">

                      <mat-icon>
                        {{ act.icon }}
                      </mat-icon>

                      {{ act.label }}

                    </span>


                    <!-- External -->

                    <span
                      class="task-tag task-tag-external"
                      *ngIf="!item.isInternal"
                      matTooltip="Completed by the resident or family through a link"
                      matTooltipClass="tooltip">

                      <mat-icon>
                        north_east
                      </mat-icon>

                      External

                    </span>


                    <!-- Required -->

                    <span
                      class="task-tag task-tag-required"
                      *ngIf="item.isRequired">

                      Required

                    </span>


                    <!-- Dependency -->

                    <span
                      class="task-tag task-tag-dependency"
                      *ngIf="taskDependency(item) as dep"
                      [matTooltip]="dep.rule"
                      matTooltipClass="tooltip">

                      <mat-icon>
                        subdirectory_arrow_right
                      </mat-icon>

                      After {{ dep.title }}

                    </span>


                    <!-- Checklist -->

                    <span
                      class="task-meta-text"
                      *ngIf="item.subTaskCount > 0">

                      {{ item.completedSubTaskCount || 0 }}/{{ item.subTaskCount }}
                      checklist items

                    </span>


                    <!-- Description -->

                    <span
                      class="task-meta-text task-description"
                      *ngIf="item.description">

                      {{ item.description }}

                    </span>

                  </div>

                </div>

              </div>


              <!-- =================================================
                   2. REQUIRED
                   ================================================= -->

              <div class="task-cell required-cell">

                <span
                  class="required-button"
                  [ngClass]="{
                    'required-active':
                    item.isRequired == true
                  }"

                  (click)="MakeTaskRequired(
                    item,
                    item.isRequired ? false : true
                  )"

                  matTooltip="Required">

                  <mat-icon>
                    check
                  </mat-icon>

                </span>

              </div>


              <!-- =================================================
                   3. ASSIGNEE
                   ================================================= -->

              <div
                class="task-cell assignee-cell"
                (click)="getTaskDetail(item)">

                <div class="assignee-wrapper">


                  <ng-container
                    *ngFor="
                      let user of getAssigne(item.taskAssignedEntity);
                      let i = index;
                      trackBy: trackByFn
                    ">


                    <!-- First 3 users -->

                    <ng-container *ngIf="i < 3">


                      <!-- User image -->

                      <div
                        *ngIf="user.image; else showInitials"
                        class="user-avatar"
                        matTooltip="{{user.name}}">

                        <img
                          [src]="user.image"
                          [alt]="user.name">

                      </div>


                      <!-- User initials -->

                      <ng-template #showInitials>

                        <div
                          class="user-avatar user-avatar-initial"
                          matTooltip="{{user.name}}">

                          {{ getShortName(user.name) }}

                        </div>

                      </ng-template>

                    </ng-container>


                  </ng-container>


                  <!-- More users -->

                  <span
                    class="more-users"
                    *ngIf="
                      getAssigne(item.taskAssignedEntity).length > 3
                    ">

                    +{{
                      getAssigne(item.taskAssignedEntity).length - 3
                    }}

                  </span>


                  <!-- No assignee -->

                  <span
                    class="no-assignee"
                    *ngIf="
                      getAssigne(item.taskAssignedEntity).length == 0
                    ">

                    -

                  </span>

                </div>

              </div>


              <!-- =================================================
                   4. DUE DATE
                   ================================================= -->

              <div
                class="task-cell due-date-cell"
                (click)="getTaskDetail(item)">


                <ng-container
                  *ngIf="isValidDueDate(item); else noDueDate">

                  <span class="due-date">
                    {{ item.dueDate | date:'MM/dd/yyyy' }}
                  </span>

                </ng-container>


                <ng-template #noDueDate>

                  <span class="no-due-date">
                    No due date
                  </span>

                </ng-template>

              </div>


              <!-- =================================================
                   5. STATUS
                   ================================================= -->

              <div class="task-cell status-cell">

                <ng-select
                  class="task-status-dropdown"

                  [readonly]="SingleTaskArchived == true"

                  formControlName="status{{item.taskId}}"

                  [searchable]="false"
                  [clearable]="false"

                  (change)="
                    onTaskListStatusChange($event,item)
                  ">


                  <ng-option
                    *ngFor="
                      let stat of taskStatusList
                    "
                    [value]="stat.taskStatusID">

                    <span
                      class="status-option"

                      [style.background]="
                        getBackground(stat.taskStatusID)
                      ">

                      {{ stat.taskStatusName }}

                    </span>

                  </ng-option>

                </ng-select>

              </div>


              <!-- =================================================
                   6. PRIORITY
                   ================================================= -->

              <div class="task-cell priority-cell">

                <ng-select
                  class="task-priority-dropdown"

                  [readonly]="SingleTaskArchived == true"

                  formControlName="priority{{item.taskId}}"

                  [searchable]="false"
                  [clearable]="false"

                  (change)="
                    onTaskListPriorityChange($event,item)
                  ">


                  <ng-option
                    *ngFor="
                      let priority of taskPriorityNameColorCode
                    "
                    [value]="priority.val">


                    <span
                      class="priority-option"

                      [ngStyle]="{
                        'color': priority.color
                      }">

                      <mat-icon>
                        {{ priority.icon }}
                      </mat-icon>

                      {{ priority.name }}

                    </span>

                  </ng-option>

                </ng-select>

              </div>


              <!-- =================================================
                   7. ACTION
                   ================================================= -->

              <div
                *ngIf="SingleTaskArchived == false"
                class="task-cell action-cell">


                <button
                  mat-icon-button
                  [matMenuTriggerFor]="taskSubActions"
                  class="action-button">

                  <mat-icon>
                    more_vert
                  </mat-icon>

                </button>


                <mat-menu
                  #taskSubActions="matMenu"
                  class="task-menu"
                  xPosition="before">


                  <button
                    mat-menu-item
                    (click)="openTaskUrl(item)">

                    <mat-icon>
                      content_copy
                    </mat-icon>

                    <span>
                      Copy URL
                    </span>

                  </button>


                  <button
                    mat-menu-item
                    (click)="sendManualTaskReminder(item)">

                    <mat-icon>
                      email
                    </mat-icon>

                    <span>
                      Send Email Notification
                    </span>

                  </button>


                  <button
                    mat-menu-item
                    (click)="ArchiveTask(item)">

                    <mat-icon>
                      archive
                    </mat-icon>

                    <span>
                      Archive
                    </span>

                  </button>


                  <button
                    mat-menu-item
                    (click)="deleteTask(item)">

                    <mat-icon>
                      delete
                    </mat-icon>

                    <span>
                      Delete
                    </span>

                  </button>

                </mat-menu>

              </div>


            </div>


            <!-- =================================================
                 NO RECORD
                 ================================================= -->

            <div
              *ngIf="ShowNoRecordFound == true"
              class="no-record">

              No record found

            </div>


          </div>

        </form>

      </mat-card>

    </div>

  </div>

</div>

    </div>

   
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="basic" (click)="closeTask()">
      Cancel
    </button>    
  </mat-dialog-actions> 

<app-task-details
  *ngIf="showTaskDetail"
  [ngClass]="{ open: showTaskDetail }"
  (closeTaskDetail)="closeTaskDetail($event)"
  (closeSaveTaskDetail)="closeSaveTaskDetail($event)"
  (showPI)="showPIntelligence($event)"
  [taskId]="taskId"
  [mainModulename]="mainModuleName" [SingleTaskArchived]="SingleTaskArchived"
  [showAddGroupButtonCore]="showAddGroupButtonCore">
</app-task-details>

  <ng-container *ngIf="showCreateTask">
      <mat-card class="createTask ssss" cdkDrag cdkDragBoundary=".right">
        <app-addtask
          (getCloseCreateTask)="getCloseCreateTask()"
          (getSaveTask)="getSaveTask()"
          [taskId]="taskId"
          [taskListID]="taskListID"
          [moduleName]="moduleNames"
          [name]="name"
          [email]="email"
          [imageUrl]="imageUrl"
          [transactionID]="transactionIDForTask"
          [typeId]="typeIdForTask" [typeIdDrp]="TypeIdDrp">
        </app-addtask>
      </mat-card>
    </ng-container>